/**
 * Copyright 2026 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */
import { useQuery, type QueryClient } from '@tanstack/react-query';
import type { Locale } from '@/types/i18n';

const getLocaleKey = () => ['locale'] as const;

const getLocaleQueryOptions = () => ({
  queryKey: getLocaleKey(),
  queryFn: () => {
    throw new Error('Query prefetch failed');
  },
  staleTime: Infinity,
  initialData: '',
  gcTime: Infinity,
});

export const getLocaleFromCache = (queryClient: QueryClient): Locale | null => {
  return queryClient.getQueryData<Locale | null>(getLocaleKey()) ?? null;
};

export const useLocaleFromCache = (): Locale | null => {
  return (useQuery(getLocaleQueryOptions()).data as unknown as Locale | null) ?? null;
};

export const prefetchLocale = (queryClient: QueryClient, locale: Locale) => {
  queryClient.setQueryData(getLocaleKey(), locale);
};

export const getLocaleQueryKey = getLocaleKey;
